export const SHIFTS = {
    minHours: 72,
    abbreviateType: [2,4]
};

export const headersExportShiftsHistoryChange = [
    {//Documento
        v: "Identificación",
        t: "s",
        s: {
            font: {
                sz: 12,
                bold: true
            }
        }
    },
    {//Nombre Completo
        v: "Nombre Completo",
        t: "s",
        s: {
            font: {
                sz: 12,
                bold: true
            }
        }
    },
    {//Base
        v: "Base",
        t: "s",
        s: {
            font: {
                sz: 12,
                bold: true
            }
        }
    },
    {//Area
        v: "Area",
        t: "s",
        s: {
            font: {
                sz: 12,
                bold: true
            }
        }
    },
     {//Zona
        v: "Zona",        
        t: "s",
        s: {
            font: {
                sz: 12,
                bold: true
            }
        }
    },
    {//Fecha
        v: "Fecha",
        t: "s",
        s: {
            font: {
                sz: 12,
                bold: true
            }
        }
    },
    {//Turno
        v: "Turno",
        t: "s",
        s: {
            font: {
                sz: 12,
                bold: true
            }
        }
    },
     {//Descripcion Turni
        v: "Descripcion Turno",
        t: "s",
        s: {
            font: {
                sz: 12,
                bold: true
            }
        }
    },
    {//Abreviado
        v: "Abreviado",
        t: "s",
        s: {
            font: {
                sz: 12,
                bold: true
            }
        }
    },
    {//Tipo de Cambio
        v: "Tipo de Cambio",
        t: "s",
        s: {
            font: {
                sz: 12,
                bold: true
            }
        }
    },
    {//Estado
        v: "Estado",
        t: "s",
        s: {
            font: {
                sz: 12,
                bold: true
            }
        }
    },
    {//Usuario Creación
        v: "Usuario Creación",
        t: "s",
        s: {
            font: {
                sz: 12,
                bold: true
            }
        }
    },
    {//Fecha Creación
        v: "Fecha Creación",
        t: "s",
        s: {
            font: {
                sz: 12,
                bold: true
            }
        }
    },
    {//Usuario Actualización
        v: "Usuario Modificación",
        t: "s",
        s: {
            font: {
                sz: 12,
                bold: true
            }
        }
    },
    {//Fecha Actualización
        v: "Fecha Modificación",
        t: "s",
        s: {
            font: {
                sz: 12,
                bold: true
            }
        }
    },
   
];